<template>
  <div>
    <el-dialog
      :title="dataForm.id ? '编辑' : '新增'"
      :visible.sync="visible"
      width="30%"
      :before-close="handleClose"
      destroy-on-close
      :close-on-click-modal="false"
    >
      <el-form
        :model="dataForm"
        :rules="rules"
        ref="dataForm"
        label-width="110px"
      >
        <el-form-item label="手机号码" prop="Tel">
          <el-input
            v-model="dataForm.Tel"
            placeholder="请输入手机号码"
            type="number"
          ></el-input>
        </el-form-item>
        <el-form-item label="ICCID" prop="ICCID">
          <el-input
            v-model="dataForm.ICCID"
            placeholder="请输入ICCID"
          ></el-input>
        </el-form-item>
        <el-form-item label="组织架构" prop="DepartmentId">
          <TenantCustomersSelectVue
            v-model="dataForm.DepartmentId"
            style="width: 100%"
            @change="changeCom"
          >
          </TenantCustomersSelectVue>
        </el-form-item>
        <el-form-item label="客户名称" prop="CompanyId">
          <el-select
            v-model="dataForm.CompanyId"
            :disabled="!dataForm.DepartmentId"
            placeholder="请选择客户公司"
          >
            <el-option
              v-for="item in companyIdForList"
              :key="item.Id"
              :label="item.Name"
              :value="item.Id"
            >
            </el-option>
          </el-select>
          <el-divider direction="vertical"></el-divider>
          <router-link to="/Custom/Custom">跳转添加客户</router-link>
        </el-form-item>
        <el-form-item label="所属运营商" prop="SupplierName">
          <el-select
            v-model="dataForm.SupplierName"
            placeholder="请选择所属运营商"
            style="width: 100%"
          >
            <el-option
              :value="v.KeyTag"
              v-for="v in yysList"
              :key="v.KeyTag"
              :label="v.KeyTag"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="省市">
          <el-cascader
            v-model="value"
            :options="City"
            :props="{ value: 'title', label: 'title', children: 'city' }"
          ></el-cascader>
        </el-form-item>
        <el-form-item label="备注" prop="Remark" v-permission="['/Card/Remark']">
          <el-input
            v-model="dataForm.Remark"
            placeholder="请输入备注"
          ></el-input>
        </el-form-item>
        <el-form-item label="是否启用过滤" prop="IsEnabled">
          <el-switch v-model="dataForm.IsEnabled" />
        </el-form-item>
        <el-form-item
          label="是否白名单"
          prop="IsWhitelist"
          v-permission="['/Card/NumberCard/BlackList']">
          <el-switch v-model="dataForm.IsWhitelist" />
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="handleClose">取 消</el-button>
        <el-button type="primary" :loading="confirmLoading" @click="ok"
          >确 定</el-button
        >
      </span>
    </el-dialog>
  </div>
</template>

<script>
import TenantCustomersSelectVue from "@/components/TenantCustomersSelect.vue";
import City from "@/api/City.json";
console.log(City);
export default {
  components: { TenantCustomersSelectVue },
  data() {
    return {
      visible: false,
      confirmLoading: false,
      companyIdForList: [], //客户列表
      City,
      value: "",
      dataForm: {
        id: "",
        Tel: "", //手机号码
        ICCID: "", //ICCID
        DepartmentId: "", //部门id
        CompanyId: "", //客户公司id
        // CompanyName: "", //客户公司名字
        SupplierName: "", //所属运营商
        IsEnabled: true, //是否启用过滤
        IsWhitelist: false, //是否白名单
        CityName: "",
        ProvinceName: "",
        Remark: "",
      },
      rules: {
        Tel: { required: true, message: "请输入手机号码", trigger: "change" },
        DepartmentId: {
          required: true,
          message: "请选择组织架构",
          trigger: "change",
        },
        SupplierName: {
          required: true,
          message: "请输入所属运营商",
          trigger: "change",
        },
        CompanyId: {
          required: true,
          message: "请选择客户公司",
          trigger: "change",
        },
      },
      yysList: [], //运营商列表
    };
  },
  methods: {
    init(id) {
      this.visible = true;
      this.getYys();
      if (id) {
        this.dataForm.id = id;
        this.$http({
          url: "/api/TelListLog/GetTelInfo?tel=" + this.dataForm.id,
          method: "get",
        }).then((res) => {
          this.$nextTick(() => {
            this.dataForm.Tel = res.data.response.Tel; //手机号码
            this.dataForm.ICCID = res.data.response.ICCID; //手机号码
            this.dataForm.DepartmentId = res.data.response.DepartmentId; //部门id
            this.dataForm.CompanyName = res.data.response.CompanyName; //客户公司名字
            this.dataForm.CompanyId = res.data.response.CompanyId; //客户公司id
            this.dataForm.SupplierName = res.data.response.SupplierName; //所属运营商
            this.dataForm.IsEnabled = res.data.response.IsEnabled; //是否启用过滤
            this.dataForm.IsWhitelist = res.data.response.IsWhitelist; //是否白名单
            this.dataForm.CityName = res.data.response.CityName;
            this.dataForm.ProvinceName = res.data.response.ProvinceName;
            this.dataForm.Remark = res.data.response.Remark;
            this.value = [
              res.data.response.ProvinceName,
              res.data.response.CityName,
            ];
            this.changeCom(res.data.response.DepartmentId);
          });
        });
      }
    },

    getYys() {
      this.$http
        .get("/api/common/GetDictionaryKeyVList?keyType=operators")
        .then((res) => {
          console.log(res);
          this.yysList = res.data.response.childrenList;
        });
    },
    //切换部门id
    changeCom(e) {
      //获取分公司下的客户
      debugger;
      this.$http({
        url:
          "/api/Common/Get?page=1&pageSize=500&key=&DepartmentId=" +
          this.dataForm.DepartmentId,
        method: "get",
      }).then((res) => {
        this.companyIdForList = res.data.response.data;
      });
    },
    handleClose() {
      this.$refs.dataForm.resetFields();
      this.visible = false;
      this.dataForm.id = "";
      this.value = "";
    },
    ok() {
      this.$refs.dataForm.validate((valid) => {
        if (valid) {
          this.confirmLoading = true;
          this.dataForm.CityName = this.value[1];
          this.dataForm.ProvinceName = this.value[0];
          let form = JSON.parse(JSON.stringify(this.dataForm));
          delete form.id;
          this.$http({
            url: !!this.dataForm.id
              ? "/api/TelListLog/ModifyTelInfo"
              : "/api/TelListLog/AddTelEntites",
            method: "post",
            data: [form],
          })
            .then((res) => {
              if (res.data && res.data.success) {
                this.confirmLoading = false;
                console.log(res);
                this.$message.success(res.data.msg);
                this.handleClose();
                this.$emit("ok");
              }
            })
            .catch((err) => {
              // console.log(err.data.msg || err.data.message);
              this.$alert(
                err.message ||
                  err.data.msg ||
                  err.data.message ||
                  "服务器未知异常",
                "操作异常提示",
                {
                  confirmButtonText: "确定",
                }
              );
            })
            .finally(() => (this.confirmLoading = false));
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
  },
};
</script>

<style></style>